// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3quF2","header":"ClearentDisclaimer_header__2CBvC","inner":"ClearentDisclaimer_inner__1QCGA"};